import React, { useState } from "react";

export const ComingSoon = () => {
    return(
        <div className='text-5xl text-gray-800 mt-20 flex items-center justify-center'>
            Page Under Construction
        </div>
    )
}